export const UPDATE_DESIGN_OPTIONS = 'fabricDesign/*/UpdateOptions';
export const RESET_DESIGN_OPTIONS = 'fabricDesign/*/ResetOptions';
export const UPDATE_PRISTINE_UYO = 'fabricDesign/*/UpdatePristineUyo';
export const SET_UPLOADED_IMAGE = 'fabricDesign/*/SetUploadedImage';
export const REVERT_TO_BASIC = 'fabricDesign/*/RevertToBasic';
